import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateAudienceForEntityList as UpdateAudienceForEntityListMutation,
    UpdateAudienceForEntityListVariables as UpdateAudienceForEntityListVariables,
    AudienceUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_AUDIENCE_FOR_ENTITY_LIST from '../mutations/update-audience-for-entity-list.graphql';

export const useUpdateAudienceForEntityList = (): {
    updateAudienceForEntityList: (arg1: AudienceUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateAudienceForEntityList, {loading, error}] = useMutation<
        UpdateAudienceForEntityListMutation,
        UpdateAudienceForEntityListVariables
    >(UPDATE_AUDIENCE_FOR_ENTITY_LIST);

    return {
        updateAudienceForEntityList: (input: AudienceUpdateInput) =>
            updateAudienceForEntityList({variables: {audience: input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
